import React, { useState } from "react";
import PropTypes from "prop-types";
import { ContentSwitcher, Switch, Row, Column } from "carbon-components-react";
import palettes from "./palettes";
import styles from "./ColorSwatch.module.scss";

function ColorSwatch(props) {
  const { formats, swatchPalettes } = props;
  const [selectedFormat, setSelectedFormat] = useState("PMS");

  const _renderSwatch = (colorName, shadeValue, formatValue, bgColor) => {
    return (
      <div
        key={formatValue}
        className={styles.swatch}
        style={{
          background: bgColor,
          color: shadeValue > 50 ? "#FFFFFF" : "#000000",
        }}
      >
        <span className={styles.swatchName}>
          {colorName} {shadeValue}
        </span>
        <span className={styles.swatchValue}>{formatValue}</span>
      </div>
    );
  };

  const _renderSwatchPalette = (shadesRows, index) => (
    <div key={index} className={styles.swatchPalette}>
      {[...shadesRows]}
    </div>
  );

  const _renderSwatchPalettes = (swatches) => (
    <div className={styles.swatchPalettes}>{[...swatches]}</div>
  );

  const _renderSwatches = (swatches, format) =>
    _renderSwatchPalettes(
      swatches.map((swatch, index) =>
        _renderSwatchPalette(
          swatch.map((colorObject) => {
            const colorName = Object.keys(colorObject)[0];
            const colorShades = Object.values(colorObject)[0];

            return colorShades.map((shadeValue) =>
              _renderSwatch(
                colorName,
                shadeValue,
                palettes[colorName][shadeValue][format],
                palettes[colorName][shadeValue].hex
              )
            );
          }),
          index
        )
      )
    );

  const switchFormat = (format) => {
    switch (format) {
      case "HEX":
        return _renderSwatches(swatchPalettes, format.toLowerCase());
      case "RGB":
        return _renderSwatches(swatchPalettes, format.toLowerCase());
      case "PMS":
        return _renderSwatches(swatchPalettes, format.toLowerCase());
      case "CMYK":
        return _renderSwatches(swatchPalettes, format.toLowerCase());
      default:
        return _renderSwatches(swatchPalettes, format.toLowerCase());
    }
  };

  return (
    <div className={styles.swatchPalettesContainer}>
      <div className={styles.stickyContentSwitcher}>
        <Row>
          <Column lg={formats.length} md={formats.length} sm={formats.length}>
            <ContentSwitcher
              className={styles.swatchPalettesFormatSwitcher}
              onChange={(format) => setSelectedFormat(format.name)}
            >
              {formats.map((format) => (
                <Switch key={format} name={format} text={format} />
              ))}
            </ContentSwitcher>
          </Column>
        </Row>
      </div>
      <div>{switchFormat(selectedFormat)}</div>
    </div>
  );
}

ColorSwatch.defaultProps = {
  formats: ["HEX", "RGB", "PMS", "CMYK"],
  swatchPalettes: [
    [{ green: [20] }, { teal: [20] }, { cyan: [20] }],
    [{ blue: [60] }, { "warm gray": [30, 20] }],
  ],
};

ColorSwatch.propTypes = {
  formats: PropTypes.arrayOf(PropTypes.oneOf(["HEX", "RGB", "PMS", "CMYK"])),
  swatchPalettes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
};

export default ColorSwatch;
